import axios from "axios";
import axiosInstance from "../../_utils/axiosConfig";

export const update = async(id,status)=>{
    try{
        const response= await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/update-reservation/${id}`,status);
        return response.data;
    }
    catch(e){
        console.log("Erreur lors de l'appel au server ",e)
        throw e;
    }
}